import { Shimmer, Stack } from "@bps/fluent-ui";

export const cancelAppointmentRecurrenceFormFallback = (
  <Stack>
    <Shimmer styles={{ shimmerWrapper: { height: 30 } }} width="100%" />
    <Shimmer width={50} />
    <Shimmer styles={{ shimmerWrapper: { height: 60 } }} width="100%" />
  </Stack>
);
